import React, {useContext, useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {Breadcrumb, Button, Form, Input, notification, Select, Space, Spin} from "antd";
import DB_ProductsGroups from "../../../../database/dictionary/products-group";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../../modal";
import {Context} from "../../../../App";
import DB_ProductsCategory from "../../../../database/dictionary/products-category";
import BackButton from "../../../tech/back_button";


const EditProductsGroups = () => {
    const {token, setToken} = useContext(Context);
    const {
        getProductsGroup,
        createProductsGroup,
        updateProductsGroup,
        statusProductsGroup,
        dependProductsGroup
    } = DB_ProductsGroups(token);
    const {getActiveProductsCategories} = DB_ProductsCategory(token)
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const params = useLocation().state;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [isLoadSystem, setIsLoadSystem] = useState(true)
    const [wait, setWait] = useState(true);
    const [isActive, setIsActive] = useState()

    const [categories, setCategories] = useState([])



    useEffect(() => {
        if (!isLoadSystem) {
            if (params.id != null) {
                getProductsGroup(params.id)
                    .then(res => {
                        setIsActive(res.status);
                        if (res.data.product_category_id[0].status === 0) {
                            res.data.product_category_id.map(cat => {
                                setCategories(current => [...current, cat]);
                            })
                        }

                        form.setFieldsValue({
                            name: res.data.name,
                            product_category_id: res.data.product_category_id[0].id
                        })
                        setWait(false);
                    })
                    .catch(e => {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    });
            } else {
                setWait(false);
            }
        }
    }, [isLoadSystem])

    useEffect(() => {
        window.scroll(0, 0)
        getActiveProductsCategories()
            .then(res => {
                setCategories(res.data);
                setIsLoadSystem(false);
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            });

    }, [])

    const checkActiveCategory = (category_id) => {
        let active = true;
        categories.map(cat => {
                if (cat.id === category_id && cat.status === 0) {
                    active = false;
                }
            }
        )
        return active;
    }

    const openNotificationFailed = (action) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_update_create', {action: action, type: t('product_group').toLowerCase()}),
            placement: 'top'
        });
    };

    const openNotificationFailedActive = (type, who) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_inactive', {type: type, what: t('product_group').toLowerCase(), who: who}),
            placement: 'top'
        });
    };

    const onFinish = async (values) => {
        setWait(true);

        if (isActive) {
            if (!checkActiveCategory(values['product_category_id'])) {
                openNotificationFailedActive(t('save').toLowerCase(), t('product_category').toLowerCase())
                setWait(false);
                return
            }
        }

        const formData = new FormData();
        formData.append('name', values["name"])
        formData.append('product_category_id', values["product_category_id"])
        if (params.id != null) {
            formData.append('id', params.id)
        }


        if (params.id == null) {
            createProductsGroup(formData)
                .then(res => {
                    if (res.status === 200) {
                        // navigate("/products/groups", {replace: true});
                        navigate(-1)
                    } else {
                        openNotificationFailed(t('creating'));

                    }
                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });
        } else {
            updateProductsGroup(formData)
                .then(res => {
                    if (res.status === 200) {
                        // navigate("/products/groups", {replace: true});
                        navigate(-1)
                    } else {
                        openNotificationFailed(t('updating'));
                    }
                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });
        }

    }


    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('product_group')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton />
                        <Button shape="round" type="primary" htmlType="submit" form={"form"}>
                            {t('save')}
                        </Button>
                    </Space>
                </Space>


                <Form
                    form={form}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 10}}
                    layout={"vertical"}
                    onFinish={onFinish}
                    autoComplete="off"
                    id={"form"}
                >
                    <Form.Item style={{marginBottom: '10pt'}}
                               name="name"
                               label={t('name')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_input', {input: t('name').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >
                        <Input showCount maxLength={100}/>
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="product_category_id"
                               label={t('product_category')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_input', {input: t('product_group').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >
                        <Select allowClear>
                            {categories.map(pa =>
                                <Select.Option key={pa.id} value={pa.id}
                                               disabled={pa.status === 0}>{pa.name}</Select.Option>
                            )}
                        </Select>
                    </Form.Item>

                </Form>
            </div>
            <Outlet/>
        </Spin>
    )
}

export default EditProductsGroups;